// extracted by mini-css-extract-plugin
export var arrow = "Pipeline-module--arrow--e2989";
export var circle = "Pipeline-module--circle--5cf0b";
export var circleWrapper = "Pipeline-module--circle-wrapper--e605c";
export var icon = "Pipeline-module--icon--7bbc2";
export var pipe = "Pipeline-module--pipe--9964c";
export var pipelineContainer = "Pipeline-module--pipeline-container--1291e";
export var typographies = "Pipeline-module--typographies--59913";